(function ($, w) {
    // Determine if the element is in the view port
    var isVisible = function (elm) {
        var rect = elm.getBoundingClientRect();
        var height = (w.innerHeight || $.documentElement.clientHeight);
        return (rect.bottom >= 0 &&
            rect.top <= height);
    };
    $.querySelectorAll('.item_anim, .img_anim').forEach(function (item) {
        function check() {
            if (!item.classList.contains('start_anim') && isVisible(item)) {
                setTimeout(function () { return item.classList.add('start_anim'); }, 100);
            }
        }
        w.addEventListener('DOMContentLoaded', check, false);
        w.addEventListener('load', check, false);
        w.addEventListener('scroll', check, false);
        w.addEventListener('resize', check, false);
    });
    $.querySelectorAll('.lazy-bg, .lazy-img').forEach(function (item) {
        function check() {
            if (!item.classList.contains('img-loaded') && isVisible(item)) {
                item.classList.add('img-loaded');
                if (item.classList.contains('lazy-bg')) {
                    item.style.backgroundImage = 'url(' + item.dataset['urlLazy'] + ')';
                }
                else {
                    item.src = item.dataset['srcLazy'];
                }
            }
        }
        w.addEventListener('DOMContentLoaded', check, false);
        w.addEventListener('load', check, false);
        w.addEventListener('scroll', check, false);
        w.addEventListener('resize', check, false);
    });
})(document, window);
